module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Carrier_SoftBank-737fd480af9cee49d9bab97cf09a475e.png";